import { render, staticRenderFns } from "./CustomShift.vue?vue&type=template&id=c90453b0&scoped=true"
import script from "./CustomShift.vue?vue&type=script&lang=js"
export * from "./CustomShift.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90453b0",
  null
  
)

export default component.exports